import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, MenuItem, Typography, Alert } from '@mui/material';
import scadenzaApi from '../../api/scadenzaApi';
import contribuenteApi from '../../api/contribuenteApi';
import documentoApi from '../../api/documentoApi';
import { useParams, useNavigate } from 'react-router-dom';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { formatDate } from '../../utils/dateFormatter';

export default function ScadenzaEditPage() {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [contribuenti, setContribuenti] = useState([]);
  const [documenti, setDocumenti] = useState([]);
  const [err, setErr] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    scadenzaApi.get(id).then(r => setForm(r.data));
  }, [id]);

  if (!form) return <div>Loading...</div>;

  const submit = async (e) => {
    e.preventDefault();
    try {
      await scadenzaApi.update(id, form);
      navigate(`/scadenze/${id}`);
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  return (
    <Container>
    <BackButtonDesktop />
      <Typography variant="h5">Modifica Scadenza</Typography>
      {err && <Alert severity="error">{String(err)}</Alert>}
      <form onSubmit={submit}>
        <TextField fullWidth sx={{ my: 1 }} label="Tipo" value={form.tipo} onChange={e => setForm({...form, tipo: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Data Scadenza" type="date" InputLabelProps={{ shrink: true }} value={form.dataScadenza} onChange={e => setForm({...form, dataScadenza: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Importo" type="number" value={form.importo} onChange={e => setForm({...form, importo: e.target.value})} />
         <TextField fullWidth sx={{ my: 1 }} label="Codice mod. Pagamento" type="number" value={form.codiceModuloPagamento} onChange={e => setForm({...form, codiceModuloPagamento: e.target.value})} />
        <Button variant="contained" type="submit">Salva</Button>
      </form>
    </Container>
  );
}